import { IconButton, Tooltip } from "@mui/material";
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import HistoryIcon from '@mui/icons-material/History';
import LinkIcon from '@mui/icons-material/Link';
import { Link as RouterLink, To, useParams } from "react-router-dom";
import useKlasisRouting from "../../utils/klasisRouting";
import useKlasisSnackbar from "../../utils/klasisSnackbar";
import useClipboard from "react-use-clipboard";
import { Translations } from "../../localization/translations";
import { useTranslation } from "react-i18next";
import SEARCH_PARAMS from "../../constants/searchParams";

interface IClassifierRecordActionsProps {
    classifierId: string;
    classifierRecordCode: string;
    isDataExpanded: boolean;
    localeCode?: string;
    hideOpenLink?: boolean;
    hideCopyLink?: boolean;
    onExpandedStateChange?: (newExpandedState: boolean) => void;
}

const ClassifierRecordActions: React.FC<IClassifierRecordActionsProps> = (
    props: IClassifierRecordActionsProps
) => {
    const { locale } = useParams();

    const { klasisRoute } = useKlasisRouting();
    const { klasisEnqueueSnackbar } = useKlasisSnackbar();
    const [isCopied, setCopied] = useClipboard(
        `${window.location.origin}/${locale}/classifications/${props.classifierId}/` +
        `${encodeURIComponent(props.classifierRecordCode)}/` +
        `${props.localeCode ? `?classifier-locale=${props.localeCode}` : ""}`
    );
    const { t } = useTranslation();

    const handleExpandButtonClick = (): void => {
        if (props.onExpandedStateChange)
            props.onExpandedStateChange(!props.isDataExpanded);
    }

    const handleCopyToClipboard = (): void => {
        setCopied();
        klasisEnqueueSnackbar(t(Translations.common.label.linkCopySuccess));
    }

    const getClassifierRecordLink = (): To => {
        let route = `classifications/${props.classifierId}/${props.classifierRecordCode}/`;

        if (props.localeCode) {
            let searchParams = new URLSearchParams();
            searchParams.append(SEARCH_PARAMS.classifierLocale, props.localeCode);

            route += `?${searchParams.toString()}`;
        }

        return klasisRoute(route);
    }

    return (
        <>
            <Tooltip title={t(Translations.common.tooltip.recordDesc)}>
                <IconButton
                    onClick={handleExpandButtonClick}
                >
                    {props.isDataExpanded ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
                </IconButton>
            </Tooltip>

            {!props.hideOpenLink && (
                <Tooltip title={t(Translations.common.tooltip.openRecord)}>
                    <IconButton
                        component={RouterLink}
                        to={getClassifierRecordLink()}
                    >
                        <HistoryIcon />
                    </IconButton>
                </Tooltip>
            )}

            {!props.hideCopyLink && (
                <Tooltip title={t(Translations.common.tooltip.copyRecordLink)}>
                    <IconButton onClick={handleCopyToClipboard}>
                        <LinkIcon />
                    </IconButton>
                </Tooltip>
            )}
        </>
    )
}

export default ClassifierRecordActions;